import { useEffect } from 'react'
import type { MapRef } from 'react-map-gl/mapbox'

export function useMapResize(
  mapRef: React.RefObject<MapRef | null>,
  containerRef: React.RefObject<HTMLDivElement | null>,
): void {
  useEffect(() => {
    const container = containerRef.current
    if (!container || typeof ResizeObserver === 'undefined') return

    let resizeTimeout: ReturnType<typeof setTimeout> | null = null
    const resizeObserver = new ResizeObserver(() => {
      if (resizeTimeout) clearTimeout(resizeTimeout)
      resizeTimeout = setTimeout(() => {
        mapRef.current?.getMap()?.resize()
      }, 16)
    })
    resizeObserver.observe(container)

    return () => {
      if (resizeTimeout) clearTimeout(resizeTimeout)
      resizeObserver.disconnect()
    }
  }, [containerRef, mapRef])
}
